import { IContactsConfig } from "@/config/contacts.config";

// Greece-specific contacts configuration override
export const greeceContactsConfig: IContactsConfig = {
  email: "info@avezor.gr",
  phone: "+306983230925",
  telegram: "https://t.me/AvezorGR",
  whatsapp: "https://wa.me/306983230925",
  // Use percent-encoded "+" for Viber deep link
  viber: "viber://chat?number=%2B306983230925",
  // wechat: "weixin://dl/chat?username=wxid_7ti09mu2ryjk12",
  address: {
    en: "Ermou 64, Athens 105 51",
    el: "Ερμού 64, Αθήνα 105 51",
    ru: "Эрму 64, Афины 105 51",
  },
  location: {
    city: "Athens",
    country: "Greece",
  },
};

export default greeceContactsConfig;
